import { ref, watch } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { medServerApiConfig } from '@/config/medserver-api.config'
import { useToast } from 'primevue'
import { toastError } from '@/utils/toast-utils'
import { ApiError, FinancialGroupLightResponse, AccountingApi } from '@/apiGenerate/medserver'
import { useI18n } from 'vue-i18n'
import { useAppUserStore } from '@/stores/appUser'
import { useCurrentEntryStore } from '@/stores/currentEntry';

const accountingApi = new AccountingApi(medServerApiConfig)

export const useFinancialGroupsStore = defineStore('financialGroups', () => {
  const toast = useToast()
  const { t } = useI18n()
  const appUserStore = useAppUserStore()
  const currentEntryStore = useCurrentEntryStore()
  const { currentDelegateUuid } = storeToRefs(currentEntryStore)

  const allFinancialGroups = ref<FinancialGroupLightResponse[]>([])
  const isLoaded = ref(false)
  const isLoading = ref(false)

  const load = async () => {
    if (!appUserStore.currHealthProPwrUuid) {
      allFinancialGroups.value = []
      isLoaded.value = false
      return
    }
    isLoading.value = true
    try {
      const result = await accountingApi.findFinancialGroupsForBillCreation({
        delegateUuid: currentDelegateUuid.value,
      })
      allFinancialGroups.value = result
      isLoaded.value = true
    } catch (error) {
      const e = error as ApiError
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: e.status ? t(`error.${e.status}`) : t('error.DEFAULT'),
      })
    } finally {
      isLoading.value = false
    }
  }

  const hasFinancialGroup = (id: number | undefined | null) =>
    id != null && allFinancialGroups.value.some(fg => fg.id === id)

  watch(
    [currentDelegateUuid, () => appUserStore.currHealthProPwrUuid],
    ([, pwr]) => { if (pwr) load() },
    { immediate: true }
  )

  return {
    allFinancialGroups,
    isLoaded,
    isLoading,
    hasFinancialGroup,
  }
})